import styled from 'styled-components';
import { VehicleSideCard } from './VehicleSideCard';
import { useGetSidePanelBidsQuery } from 'services/api/my-bids';
import { AUCTION_TYPES, VEHICLE_STATUSES } from '../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Icon } from '@material-ui/core';
import { toggleCollapsed } from 'services/sidePanel/sidePanel';
// import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const SidePanelWrapper = styled.div<{ version: 'live-auction' | 'details'; isCollapsed: boolean }>`
  position: absolute;
  width: 226px;
  right: 0;
  top: ${props => (props.version === 'live-auction' ? '0px' : '8px')};
  bottom: 0;
  overflow-y: scroll;
  height: ${props => (props.version === 'live-auction' ? 'calc(100% + 24px + 24px)' : 'calc(100% - 20px)')};
  margin-top: ${props => (props.version === 'live-auction' ? '-24px' : '0')};

  @media (max-width: 1280px) {
    display: none;
  }
`;

const Container = styled.div<{ isCollapsed: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 40px 8px 32px 8px;
  height: 100%;
  gap: 12px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  overflow-y: auto;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  transform: translateX(${props => (props.isCollapsed ? '100%' : '0')});
  transition: transform 0.3s ease-in-out;

  /* total width */
  &::-webkit-scrollbar {
    background-color: #fff;
    width: 16px;
  }

  /* background of the scrollbar except button or resizer */
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  /* scrollbar itself */
  &::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #fff;
  }

  /* set button(top and bottom of the scrollbar) */
  &::-webkit-scrollbar-button {
    display: none;
  }
`;

// left: ${props => (props.isCollapsed ? 'calc(100% - 40px)' : 'calc(100% - 20px - 256px)')};
// transform: translateY(-50%);
// left: ${props => (props.isCollapsed ? 'calc(100% - 40px)' : '-20px')}
const ToggleButton = styled.button<{ isCollapsed: boolean }>`
  position: fixed;
  left: ${props => (props.isCollapsed ? 'calc(100% - 40px)' : 'calc(100% - 246px)')};
  top: 50vh;
  width: 40px;
  height: 40px;
  transform: translateY(-50%);
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5555;
  transition: left 0.3s ease-in-out;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    width: 20px;
    height: 20px;
    color: #666;
  }
`;

type Props = {
  hidden?: boolean;
  version?: 'live-auction' | 'details';
};

export const VehicleSidePanel = ({ hidden = false, version = 'live-auction' }: Props) => {
  const isCollapsed = useSelector((state: any) => state.sidePanel.isCollapsed);
  const dispatch = useDispatch();
  const togglePanel = () => {
    dispatch(toggleCollapsed());
  };
  // const [wrapperBoundingRect, setWrapperBoundingRect] = useState<DOMRect | null>(null);
  const user = useSelector((state: any) => state.user?.user);
  const { data } = useGetSidePanelBidsQuery(undefined, { skip: !user || user.role !== 'buyer' });
  const items =
    data?.rows?.ids
      .map(id => data?.rows?.entities[id]!)
      ?.filter(
        item =>
          item.status === VEHICLE_STATUSES.ACTIVE && (item.auction.type === AUCTION_TYPES.AUTOAXESS || item.in_battle)
      ) ?? [];

  const ref = useRef<HTMLDivElement>(null);

  if (items.length === 0) return null;

  return (
    <SidePanelWrapper version={version} hidden={hidden} ref={ref} isCollapsed={isCollapsed}>
      <ToggleButton
        isCollapsed={isCollapsed}
        onClick={togglePanel}
        aria-label={isCollapsed ? 'Expand panel' : 'Collapse panel'}
      >
        {isCollapsed ? <Icon>keyboard_arrow_left</Icon> : <Icon>keyboard_arrow_right</Icon>}
      </ToggleButton>
      <Container isCollapsed={isCollapsed}>
        {items.map(vehicle => {
          return <VehicleSideCard vehicle={vehicle} key={vehicle.id} />;
        })}
      </Container>
    </SidePanelWrapper>
  );
};
